import React, {FC} from 'react';
import SessionRateImg from 'assets/images/session-rate-banner.png';
import SessionRateImgWebp from 'assets/images/session-rate-banner.webp';
import SessionRateImg2x from 'assets/images/session-rate-banner@2x.png';
import SessionRateImgWebp2x from 'assets/images/session-rate-banner@2x.webp';
import SessionRateImg3x from 'assets/images/session-rate-banner@3x.png';
import SessionRateImgWebp3x from 'assets/images/session-rate-banner@3x.webp';
import {LazyImage} from 'hooks';
//@ts-ignore
import lqip from 'lqip.macro';

const SessionRateImgLqip = lqip(
  '../../../../../assets/images/session-rate-banner.png',
);

type Props = {
  imageUtilities?: string;
};

export const SessionRateBanner: FC<Props> = ({
  imageUtilities = 'max-w-full',
}) => {
  return (
    <LazyImage
      src={SessionRateImg}
      srcSet={`${SessionRateImg}, ${SessionRateImg2x} 2x, ${SessionRateImg3x}`}
      webp={`${SessionRateImgWebp}, ${SessionRateImgWebp2x} 2x, ${SessionRateImgWebp3x}`}
      type="image/png"
      alt="Session Rate"
      className={`${imageUtilities} object-contain`}
      aspectRatio={3 / 2}
      lqip={SessionRateImgLqip}
    />
  );
};
